import { render } from "./RiwayatJadwalPelajaran.vue?vue&type=template&id=02fe5184"
import script from "./RiwayatJadwalPelajaran.vue?vue&type=script&lang=js"
export * from "./RiwayatJadwalPelajaran.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__